import { DefaultCheckbox, FormGroup } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

export default function CheckboxProperty({ name, label }) {
  const { value, setValue } = useCraftProp(name)

  return <DefaultCheckbox
    id={name}
    name={name}
    value={value}
    onChange={setValue}
  >
    {label}
  </DefaultCheckbox>
}

export function CheckboxGroupProperty({ options }) {
  return <FormGroup>
    {options.map(({ value, label }, idx) => <CheckboxProperty key={idx}
      name={value}
      label={label}
    />)}
  </FormGroup>
}
